<template>
  <div>
    <b-nav-item
      v-if="isDisplayEnterButton"
      @click="onClickEntryExit"
      class="rounded-pill"
      v-b-tooltip.noninteractive
      :title="isAuthenticated ? 'Выход' : 'Вход'"
    >
      <span class="text-white mr-2" v-if="!isMobile && !isAuthenticated">
        Вход
      </span>
      <font-awesome-icon
        :icon="isAuthenticated ? ['fa', 'sign-out-alt'] : ['fa', 'sign-in-alt']"
        class="text-white pt-1 entry-exit-button"
      />
    </b-nav-item>

    <b-modal ref="logoutModal" title="Выход из системы" @ok="onLogoutOK">
      <p>Вы уверены, что хотите выйти из системы?</p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button @click="ok()" variant="primary"> ОК </b-button>
        <b-button @click="cancel()"> Отмена </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { userMappers } from '@/store/modules/user'
import Config from '@/config/config'
import { BModal } from 'bootstrap-vue'
import { mobileWidthMapper } from '@/store/modules/mobileWidth'

const Mappers = Vue.extend({
  computed: {
    ...userMappers.mapGetters(['isAuthenticated']),
    ...mobileWidthMapper.mapGetters(['isMobile']),
  },
})

@Component
export default class LogInOut extends Mappers {
  public $refs!: {
    logoutModal: BModal
  }

  private get isDisplayEnterButton() {
    return this.$route.path !== Config.routing.authPage.path
  }

  private onClickEntryExit() {
    this.isAuthenticated ? this.onLogout() : this.onLogin()
  }

  private onLogin() {
    this.$router.push(Config.routing.authPage.path)
  }

  private onLogout() {
    this.$refs.logoutModal.show()
  }

  private onLogoutOK() {
    this.$router.push('/logout')
  }
}
</script>

<style scoped>
.entry-exit-button {
  font-size: 1.3em;
}
</style>
